import React from 'react';

/**
 * Event-Utilities für komponenten-übergreifende Kommunikation
 */

// Event-Typen
export interface ProviderUpdateEvent {
  providerId: string;
  updates: {
    title?: string;
    status?: string;
    [key: string]: any;
  };
}

export interface ContractUpdateEvent {
  providerId: string;
  contractId: string;
  updates: {
    title?: string;
    status?: string;
    documentsCount?: number;
    [key: string]: any;
  };
}

/**
 * Sendet ein Provider-Update Event
 */
export const dispatchProviderUpdate = (providerId: string, updates: ProviderUpdateEvent['updates']) => {
  const event = new CustomEvent('providerUpdated', {
    detail: { providerId, updates }
  });
  window.dispatchEvent(event);
};

/**
 * Sendet ein Contract-Update Event
 */
export const dispatchContractUpdate = (providerId: string, contractId: string, updates: ContractUpdateEvent['updates']) => {
  const event = new CustomEvent('contractUpdated', {
    detail: { providerId, contractId, updates }
  });
  window.dispatchEvent(event);
};

/**
 * Hook für Provider-Update Events
 */
export const useProviderUpdateListener = (callback: (event: ProviderUpdateEvent) => void) => {
  React.useEffect(() => {
    const handleProviderUpdate = (event: CustomEvent<ProviderUpdateEvent>) => {
      callback(event.detail);
    };

    window.addEventListener('providerUpdated', handleProviderUpdate as EventListener);
    
    return () => {
      window.removeEventListener('providerUpdated', handleProviderUpdate as EventListener);
    };
  }, [callback]);
};

/**
 * Hook für Contract-Update Events
 */
export const useContractUpdateListener = (callback: (event: ContractUpdateEvent) => void) => {
  React.useEffect(() => {
    const handleContractUpdate = (event: CustomEvent<ContractUpdateEvent>) => {
      callback(event.detail);
    };

    window.addEventListener('contractUpdated', handleContractUpdate as EventListener);
    
    return () => {
      window.removeEventListener('contractUpdated', handleContractUpdate as EventListener);
    };
  }, [callback]);
}; 